<mat-nav-list [ngClass]="{ 'list-is-open': expandedElement === menu() }">
  <a
    (isActiveChange)="isActiveChange()"
    mat-list-item
    [routerLink]="!menu().route ? null : menu().route"
    disableRipple="true"
    routerLinkActive="item-selected"
    aria-current="page"
    (click)="changeMenuState()"
  >
    <span class="menu-icon">
      <section class="icon">
        <span [class]="menu().icon ?? 'no-icon'"></span>
      </section>
      {{ menu().name }}
    </span>
    @if (menu().children.length) {
      <span class="chevron">
        <span [ngClass]="{ rotate: expandedElement === menu() }" class="sub_icon icon-chevron-down"></span>
      </span>
    }
  </a>
  @for (children of menu().children; track children.route ? children.route : children) {
    <!-- @if (children.showMenu) { -->
    <mat-nav-list class="expandable" [class.expanded]="expandedElement === menu()" [class.collapse]="expandedElement !== menu()">
      <app-nav-item [menu]="children" [parentMenu]="menu()" [parentMenuIsOpen]="expandedElement === menu()" />
    </mat-nav-list>
    <!-- } -->
  }
</mat-nav-list>
